import React from "react"

import CircleCheckIcon from "@components/elements/V2/Icons/CircleCheckIcon"
import LockIcon from "@components/elements/V2/Icons/LockIcon"
import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"

export const InfoSectionSupportSubscript = () => (
  <div className="flex flex-wrap items-center gap-12 sm:justify-center">
    <div className="flex items-center gap-4">
      <CircleCheckIcon
        opacity={1}
        checkmarkClassName="stroke-blue"
        borderClassName="stroke-blue"
      />
      <Typography
        font="grotesk"
        size="body-sm"
        weight="book"
        color={Color.Black}
        text="Get 24/7 support"
      />
    </div>
    <div className="flex items-center gap-2">
      <CircleCheckIcon
        opacity={1}
        checkmarkClassName="stroke-blue"
        borderClassName="stroke-blue"
      />
      <Typography
        font="grotesk"
        size="body-sm"
        weight="book"
        color={Color.Black}
        text="No contracts"
      />
    </div>
    <div className="flex items-center gap-2">
      <LockIcon pathClassName="stroke-blue" />
      <Typography
        font="grotesk"
        size="body-sm"
        weight="book"
        color={Color.Black}
        text="100% secure shopping"
      />
    </div>
  </div>
)
